import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const MissionSection = () => {
  const { t, isRTL } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="mission" className="section-padding bg-charcoal relative overflow-hidden">
      {/* Subtle yellow accent */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Tagline */}
          <p className="text-gold text-xs sm:text-sm uppercase tracking-[0.2em] sm:tracking-[0.3em] mb-3 sm:mb-4 font-medium">
            {t.mission.tagline}
          </p>
          
          {/* Headline - Yellow */}
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl xl:text-5xl text-gold leading-tight mb-6 sm:mb-8 px-2">
            {t.mission.headline}
          </h2>

          <div className="gold-divider mb-8 sm:mb-12" />

          {/* Content */}
          <div className="space-y-4 sm:space-y-6 mb-8 sm:mb-12 px-2">
            {t.mission.content.map((paragraph, index) => (
              <p 
                key={index} 
                className={`leading-relaxed ${
                  index === 0 ? 'text-lg sm:text-xl lg:text-2xl font-light text-cream' : 'text-base sm:text-lg text-cream-300'
                }`}
              >
                {paragraph}
              </p>
            ))}
          </div>

          {/* CTA */}
          <button
            onClick={() => scrollToSection('programs')}
            className="btn-gold w-full sm:w-auto"
          >
            {t.mission.cta}
          </button>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;